import { render, staticRenderFns } from "./Avisos.vue?vue&type=template&id=b284a7ea&scoped=true"
import script from "./Avisos.vue?vue&type=script&lang=js"
export * from "./Avisos.vue?vue&type=script&lang=js"
import style0 from "./Avisos.vue?vue&type=style&index=0&id=b284a7ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b284a7ea",
  null
  
)

export default component.exports